/**
 * Cleans up a search params object.
 * Removes keys whose values are falsy
 * @param params The search params to set in the url
 */ import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
export var cleanupSearchParams = function(params) {
    return Object.entries(params).reduce(function(memo, param) {
        var _param = _sliced_to_array(param, 2), _$param = _param[0], paramValue = _param[1];
        if (paramValue) {
            memo[_$param] = paramValue;
        }
        return memo;
    }, {});
};

//# sourceMappingURL=cleanupSearchParams.js.map